<template>
  <div class="milestones">
    <div class="milestones__header">Significant events in my journey</div>
    <div class="milestone">
      <div class="milestones__title">Portfolio</div>
      <div class="milestones__description">To showcase my profile, skills, and experiences to the world, and to mess with new new technologies.</div>
      <a href="https://andoshin11.github.io/" target="_blank" class="milestones_link">https://andoshin11.github.io/</a>
      <div class="milestones__skills skills">
        <span class="skills__skill">ES6</span>
        <span class="skills__skill">Vue.js</span>
        <span class="skills__skill">vue-cli</span>
        <span class="skills__skill">vue-router</span>
        <span class="skills__skill">GitHub Pages</span>
      </div>
      <div class="work__images"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'works',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
$black: #2c3e50;
$green: #41BAA4;
$green-dark: #067e76;

body {
  font-size: 12px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: $green-dark;
  text-decoration: underline;
  cursor: pointer;
  &:hover{
    opacity: .7;
  }
}

.skills {
  &__skill {
    display: inline-block;
    border: 1px solid $black;
    border-radius: 3px;
    padding: 0 5px;
    font-size: 16px;
    line-height: 1.5;
    margin-right: 3px;
    margin-bottom: 6px;
  }
}
.works {
  display: block;
  width: 60%;
  margin: auto;
  padding-bottom: 300px;
  &__header {
    font-size: 32px;
    line-height: 5;
    font-weight: bold;
  }
}

@media screen and (max-width: 767px) {
  .works {
    width: 100%;
    padding-bottom: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// Milestones.vue?1ada33a0